import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Informes/seguimientoExtraccionesPoolSeguimiento`, method: 'POST', body: values, token: token})
}